<template>
  <v-container>
    <page-heading>{{ pageTitle }}</page-heading>

    <div class="d-flex justify-end mb-2">
      <v-btn
          color="primary"
          @click="openCreateMiscModal"
      ><v-icon left>mdi-book-plus</v-icon>{{ trans('misc.accountCreate') }}</v-btn>
    </div>

    <ajax-table
        ref="miscAccountsTable"
        :resource="resourceUrl"
        :headers="[
          {text: 'misc.accountNbr', value: 'accountNbr'},
          {text: 'misc.description', value: 'description'},
          {text: '', value: 'actions', sortable: false}
        ]"
        :page-options="{itemsPerPage: 20}"
        :items-per-page-options="[10, 20, 50]"
        filterable
        :filter="filter"
    >

      <template v-slot:filters>
        <search v-model="filterData.description" />
      </template>

      <template v-slot:item.actions="{ item }">
        <context-menu-icon>
          <v-list dense>
            <v-list-item @click="openMiscAccountEditModal(item)">
              <v-list-item-icon><v-icon left small>{{ 'mdi-file-edit'}}</v-icon></v-list-item-icon>
              <v-list-item-title>{{ trans('general.edit') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="requestMiscAccountDeletion(item)">
              <v-list-item-icon><v-icon left small>{{ 'mdi-delete' }}</v-icon></v-list-item-icon>
              <v-list-item-title>{{ trans('general.delete') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </context-menu-icon>
      </template>
    </ajax-table>

    <confirm-deletion-modal
        :title="trans('misc.accountDelete')"
        :show-modal="miscAccountToDelete != null"
        @confirm="deleteMiscAccount(miscAccountToDelete.id)"
        @close="miscAccountToDelete = null"
    >
      <template v-if="miscAccountToDelete">
        <b>{{ trans('misc.accountNbr') }}: </b>
        {{ miscAccountToDelete.accountNbr }}
        <b>{{ trans('misc.description') }}: </b>
        {{ miscAccountToDelete.description }}
      </template>
    </confirm-deletion-modal>

    <misc-account-edit-modal
      :show-modal="miscAccountToEdit != null"
      :initial-misc-account="miscAccountToEdit"
      @success="reloadData"
      @close="miscAccountToEdit = null"
    />

  </v-container>
</template>

<script>
import PageHeading from '../components/PageHeading';
import AjaxTable from '../components/AjaxTable';
import {RouterUtils} from '../utils/router-utils';
import ConfirmDeletionModal from "@/components/ConfirmDeletionModal";
import MiscAccountEditModal from "@/components/MiscAccountAdditModal";
import {LocaleUtils} from '../utils/locale-utils';
import {MainUtils} from '../utils/main-utils';
import {MiscAccountApi} from "@/api/misc-account-api";
import ContextMenuIcon from '../components/ContextMenuIcon';
import {comparison, eq, or} from "rsql-builder";
import {like} from "@/lib/custom-rsql-operators";
import Search from '@/components/Search';

export default {
  name: 'MiscAccountsPage',
  mixins: [
    MainUtils,
    RouterUtils,
    LocaleUtils
  ],
  components: {
    ConfirmDeletionModal,
    MiscAccountEditModal,
    AjaxTable,
    ContextMenuIcon,
    PageHeading,
    Search
  },
  data: () => ({
    miscAccountToDelete: null,
    miscAccountToEdit: null,
    filterData: {
      description: null
    }
  }),

  computed: {
    canAssignGroup() {
      return this.hasAnyPermission('OBJECT_EDIT');
    },
    filter () {
      let filters =  [];
      if(this.filterData.description) {
        filters.push(
            or(
                comparison('accountNbr', like(this.filterData.description)),
                comparison('description', like(this.filterData.description))
            )
        )
      }
      return filters;
    },
    resourceUrl () {
      return MiscAccountApi.apiUri;
    },
    pageTitle () {
      return this.trans('misc.accounts');
    }
  },

  methods: {
    openMiscAccountEditModal(miscAccount) {
      this.miscAccountToEdit = miscAccount;
    },
    requestMiscAccountDeletion(miscAccount) {
      this.miscAccountToDelete = miscAccount;
    },
    deleteMiscAccount(id) {
      MiscAccountApi.deleteMiscAccount(id);
      this.reloadData();
    },
    reloadData() {
      this.$refs.miscAccountsTable.loadData();
    },
    openCreateMiscModal() {
      this.miscAccountToEdit = {};
    }
  }
}
</script>

<style>
</style>
